export const environment = {
  production: false,

  // AWS Cognito Configuration
  cognito: {
    userPoolId: 'ap-southeast-4_9W9nJd1yS',
    userPoolWebClientId: '6t43js9eqgftme0t4o4jsios5b',
    region: 'ap-southeast-4',
  },

  // API Configuration
  api: {
    baseUrl: 'https://suppliers-dev2.winning.com.au/supplier'
  },

  // Cognito OAuth Configuration
  cognitoOAuth: {
    clientId: '6t43js9eqgftme0t4o4jsios5b',
    redirectUri: 'https://suppliers-dev2.winning.com.au/login/callback',
    domain: 'https://winnsdhtestdomain.auth.ap-southeast-4.amazoncognito.com'
  },

  hmac : {
    key : "",
    secretName: 'winn-sdh-apse2-test-hmac-sm',
  }
};
